var MpPageParticipationDetail;

(function() {
    if (!document.querySelector('#vue-body-participation')  || GLOBAL_SECTION !== 'participation') {
        return;
    }

    MpPageParticipationDetail = new Vue({
        el: '#vue-body-participation',
        mixins: [MpVideoModal],
        data: {
            isInitialized: false,
        },
        computed: {
        },
        methods: {

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
            },
        },
        filters: {},

        mounted: function() {
            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },

        destroy: function() {}
    });

})();
